/* eslint-disable */

const routes = {"dashboard_company:index": "/dashboard/company/", "dashboard_company:overview": "/dashboard/company/overview/", "dashboard_company:companies:account": "/dashboard/company/account/", "dashboard_company:companies:profile": "/dashboard/company/company-profile/", "dashboard_company:company_registrations:register": "/dashboard/company/register/", "dashboard_company:company_registrations:select_students": "/dashboard/company/select-students/", "dashboard_company:company_registrations:update_student_registation": "/dashboard/company/select-students/<int:pk>/", "dashboard_company:company_registrations:selected_students": "/dashboard/company/selected-students/", "dashboard_company:company_registrations:download_cv": "/dashboard/company/download-cv/<int:pk>/", "dashboard_company:users:login": "/dashboard/company/login/", "dashboard_company:users:logout": "/dashboard/company/logout/", "dashboard_company:users:change_password": "/dashboard/company/change-password/", "dashboard_company:users:password_reset": "/dashboard/company/forgot-password/", "dashboard_company:users:password_reset_done": "/dashboard/company/forgot-password/done/", "dashboard_company:users:password_reset_confirm": "/dashboard/company/forgot-password/reset/<uidb64>/<token>/", "dashboard_company:users:password_reset_complete": "/dashboard/company/forgot-password/completed/", "dashboard_student:index": "/dashboard/student/", "dashboard_student:users:login": "/dashboard/student/login/", "dashboard_student:users:logout": "/dashboard/student/logout/", "dashboard_student:users:account": "/dashboard/student/account/", "dashboard_student:users:change_password": "/dashboard/student/change-password/", "dashboard_student:users:password_reset": "/dashboard/student/forgot-password/", "dashboard_student:users:password_reset_done": "/dashboard/student/forgot-password/done/", "dashboard_student:users:password_reset_confirm": "/dashboard/student/forgot-password/reset/<uidb64>/<token>/", "dashboard_student:users:password_reset_complete": "/dashboard/student/forgot-password/completed/", "dashboard_student:student_registrations:register": "/dashboard/student/register/", "dashboard_student:student_registrations:register_success": "/dashboard/student/register/success/", "dashboard_student:student_registrations:activate": "/dashboard/student/activate/<uidb64>/<token>/", "dashboard_student:student_registrations:activation_failed": "/dashboard/student/activate/failed/", "dashboard_student:student_registrations:send_account_activation": "/dashboard/student/send-account-activation/", "dashboard_student:student_registrations:send_account_activation_success": "/dashboard/student/send-account-activation-success/", "dashboard_student:student_registrations:profile": "/dashboard/student/profile/", "dashboard_student:student_registrations:activities": "/dashboard/student/activities/", "dashboard_student:student_registrations:workshops": "/dashboard/student/workshops/", "workshops:list": "/workshop-weeks/", "editions:contact": "/contact/", "editions:kick_off": "/kick-off/", "editions:lunch_lecture": "/lunch-lecture/", "editions:career_fair": "/career-fair/", "companies:list": "/companies/", "companies:detail": "/companies/<slug>/", "home": "/", "about": "/about/", "company_experience_weeks": "/company-experience-weeks/", "cookie_policy": "/cookie-policy/", "for_companies": "/for-companies/", "privacy_statement": "/privacy-statement/"} as const;

// examples:
// const routes = {
//     home: "/",
//     "books:book_detail": "/books/<int:pk>/",
//     "users:reset_password": "/users/reset-password/<uidb64>/<token>/",
// } as const;

type _UnwrapParam<
    P extends string,
    S extends string[]
> = P extends `<${infer Q}>` ? [Q, ...S] : S;

type _Match<
    T extends string,
    S extends string[]
> = T extends `${infer P}/${infer R}`
    ? _Match<R, _UnwrapParam<P, S>>
    : _UnwrapParam<T, S>;

type Match<T extends string> = _Match<T, []>[number];

type ExtractKey<T extends string> = T extends `${string}:${infer K}` ? K : T;
type ExtractType<T extends string> = T extends `int:${string}`
    ? number
    : string;
type Extractor<T extends string> = {
    [K in Match<T> as ExtractKey<K>]: ExtractType<K>;
};

export type RouteKeys = keyof typeof routes;
export type Route<T extends RouteKeys> = (typeof routes)[T];
export type RouteParams<T extends RouteKeys> = Extractor<Route<T>>;

function reverseUrl<T extends RouteKeys>(
    urlName: T,
    ...args: Record<string, never> extends RouteParams<T>
        ? [args?: never]
        : [args: RouteParams<T>]
): Route<T> {
    const url = routes[urlName];

    const argTokens = url.match(/<(\w+\:)?\w*>/g);
    if (!argTokens && args.length > 0) {
        throw (
            "Invalid URL lookup: URL '" +
            urlName +
            "' does not expect any arguments."
        );
    }

    if (argTokens) {
        return argTokens.reduce((acc, token) => {
            if (args[0] === undefined) {
                throw (
                    "Invalid URL lookup: URL '" +
                    urlName +
                    "' expects " +
                    argTokens.length +
                    " arguments."
                );
            }
            // Remove the type prefix from the token, e.g. "<int:pk>" -> "pk"
            const argName = token.slice(1, -1).replace(/^\w+\:/, "") as keyof RouteParams<T>;
            // Get the value of the argument, e.g. { pk: 1 } -> 1
            const argValue = String(args[0][argName]);
            return acc.replace(token, argValue);
        }, url) as Route<T>;
    }

    return url;
}

export default reverseUrl;
